export default "__VITE_ASSET__BmWLb_cE__"